import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import type { SiteGateUpdate } from "../types/siteGate";
import * as siteGateApi from "../services/siteGateApi";

export const siteGateKeys = {
  all: ["site-gate"] as const,
};

export function useSiteGate() {
  return useQuery({
    queryKey: siteGateKeys.all,
    queryFn: () => siteGateApi.getSiteGate(),
  });
}

export function useUpdateSiteGate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: SiteGateUpdate) => siteGateApi.updateSiteGate(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: siteGateKeys.all });
    },
  });
}
